import {logoMap} from './logos'

export function Logo({name}: {name: string}) {
  const Component = logoMap[name]
  if (Component) {
    return <Component />
  }
  return null
}
